var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.197,
    height: 18.225,
    viewBox: "0 0 16.197 18.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3552",
    "data-name": "Rectangle 3552",
    width: 16.197,
    height: 18.225,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10470",
    "data-name": "Group 10470",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10469",
    "data-name": "Group 10469",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27778",
    "data-name": "Path 27778",
    d: "M14.178,11a6.112,6.112,0,0,1-12.008.437A5.956,5.956,0,0,1,8.119,4.05V6.075L13.2,3.037,8.119,0V2.025a8.106,8.106,0,1,0,8.068,9.239A1.013,1.013,0,0,0,14.178,11",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResentIcon);
export default __webpack_public_path__ + "static/media/resent-icon.4980c8d375aea7c88f492ca3b339b2b9.svg";
export { ForwardRef as ReactComponent };